import {
  FETCH_PERFORMER_EARNINGS_START,
  FETCH_PERFORMER_EARNINGS_SUCCESS,
  FETCH_PERFORMER_EARNINGS_FAILURE
} from "../actions/ActionConstant";

export const initialState = {
  earnings: {
    data: {},
    loading: false,
    error: false,
  }
};
const Face2FacePaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERFORMER_EARNINGS_START:
      return {
        ...state,
        earnings: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_PERFORMER_EARNINGS_SUCCESS:
      return {
        ...state,
        earnings: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_PERFORMER_EARNINGS_FAILURE:
      return {
        ...state,
        earnings: {
          data: action.data,
          loading: false,
          error: true,
        },
      };
    default:
      return state;

  };
}

export default Face2FacePaymentReducer;
